import React from 'react';
import PropTypes from 'prop-types';

import FaqElementComponent from './FaqElementComponent';

class FaqThemeComponent extends React.Component {
    render() {
        const { theme, hashId } = this.props;

        return (
            <div className="faq-theme">
                <h2>{theme.label}</h2>
                {theme.faqs.map(faq => (
                    <FaqElementComponent key={faq.id} faq={faq} hashId={hashId} />
                ))}
            </div>
        );
    }
}

FaqThemeComponent.propTypes = {
    theme: PropTypes.object.isRequired
};

export default FaqThemeComponent;



// WEBPACK FOOTER //
// ./src/components/pages/faq/FaqThemeComponent.js